// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/doc.yaml
// 生成时间: 2026-08-28T07:43:12.568Z
import http from '../http';

export default {
  // 列表 doc.list
  list: (data) => http.get('content-service/doc_article/page', data),

  // 详情 doc.info
  info: (id) => http.get('content-service/doc_article/' + id),

  // 创建 doc.add
  add: (data) => http.post('content-service/doc_article', data),

  // 更新 doc.update
  update: (data) => http.put('content-service/doc_article', data),

  // 删除 doc.del
  del: (id) => http.delete('content-service/doc_article/' + id, {}),

  type: {
    // 文档分类树 doc.type.tree
    tree: (data) => http.get('content-service/doc_category/tree', data),

    // 新增文档分类 doc.type.add
    add: (data) => http.post('content-service/doc_category', data),

    // 更新文档分类 doc.type.update
    update: (data) => http.put('content-service/doc_category', data),

    // 删除文档分类 doc.type.delete
    delete: (id) => http.delete('content-service/doc_category/' + id, {}),
  },

  // 文档专题 doc.topic
  topic: (data) => http.get('content-service/doc_article/page/for/topic', data),
};
